/**
 * Collection Filters
 * 
 * @module collection-filters
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'collection-filters';

if (!customElements.get(customElements.component)) {
    class CollectionFilters extends HTMLElement {

        /**
         * Collection filters web component.
         * 
         * @constructor
         */
        constructor() {
            super();
            this.filterData = [];
            this.lastSearchParams = '';
            this.initEvents();
            this.renderCounts();
            this.countRenderFiltersSelected();
            this.filterSwitchOption();
        }

        /**
         * Init component events.
         * 
         * @returns {undefined}
         */
        initEvents() {
            this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

            // Define debounce function
            this.debounce = (func, wait) => {
                let timeout;
                return function (...args) {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(this, args), wait);
                };
            };

            this.debouncedOnSubmit = this.debounce((event) => {
                if (this.filterForm) {
                    if (!this.filterForm.dataset.hasOwnProperty('filtersLeft') || screen.width > 768) {
                        this.onSubmitHandler(event);
                    }
                }
            }, 150);

            this.filterForm = this.querySelector('form');
            if (this.filterForm) {
                // Event listener for checkboxes
                this.filterForm.querySelectorAll('input[type="checkbox"]').forEach(input => {
                    input.addEventListener('click', (event) => {
                        this.onSubmitHandler(event);
                    });
                });

                // Event listener for number inputs
                this.filterForm.querySelectorAll('input[type="number"]').forEach(input => {
                    input.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            const formData = new FormData(this.filterForm);
                            const searchParams = new URLSearchParams(formData).toString();
                            this.renderPage(searchParams, event);
                        }
                    });
                });
            }

            const button = document.querySelector("[data-filter-submit]");
            if (button && !button.classList.contains('disabled')) {
                button.addEventListener('click', event => {
                    if (this.filterForm) {
                        const formData = new FormData(this.filterForm);
                        const searchParams = new URLSearchParams(formData).toString();
                        this.renderPage(searchParams, event);
                    }
                });
            }

            window.addEventListener('popstate', this.onHistoryChange.bind(this));

            this.querySelectorAll('.filter-btn').forEach(item => {
                item.addEventListener('click', e => {
                    e.preventDefault();
                    item.parentElement.classList.toggle('active');
                    item.innerHTML = item.parentElement.classList.contains('active') ? 'Show less' : 'Show more';
                });
            });
        }

        /**
         * On submit handler event.
         * 
         * @param {object} event Event.
         * @returns {undefined}
         */
        onSubmitHandler(event) {
            event.preventDefault();
            const formData = new FormData(event.target.closest('form'));
            const searchParams = new URLSearchParams(formData).toString();
            if (searchParams !== this.lastSearchParams) {
                this.lastSearchParams = searchParams;
                this.renderPage(searchParams, event);
            }
        }

        /**
         * On active filter click event.
         * 
         * @param {object} event Click event.
         * @returns {undefined}
         */
        onActiveFilterClick(event) {
            event.preventDefault();
            const searchParams = new URL(event.currentTarget.href).searchParams.toString();
            if (searchParams !== this.lastSearchParams) {
                this.lastSearchParams = searchParams;
                this.renderPage(searchParams);
            }
        }

        /**
         * Render page content.
         * 
         * @param {string} searchParams URL params.
         * @param {object} event Click event.
         * @param {boolean} updateURLHash update URL hash.
         * @returns {undefined}
         */
        renderPage(searchParams, event, updateURLHash = true) {
            document.getElementById('CollectionProductGrid').classList.add('collection-filter-loading');
            const url = `${window.location.pathname}?${searchParams}`;
            const filterDataUrl = element => element.url === url;

            if (this.filterData.some(filterDataUrl)) {
                this.renderSectionFromCache(filterDataUrl, event);
            } else {
                this.renderSectionFromFetch(url, event);
            }

            if (updateURLHash) this.updateURLHash(searchParams);
            this.countRenderFiltersSelected();
        }

        /**
         * Render section from fetch.
         * 
         * @param {string} url String url.
         * @param {object} event Event.
         * @returns {undefined}
         */
        renderSectionFromFetch(url, event) {
            fetch(url).then(response => response.text()).then((responseText) => {
                const html_dom = new DOMParser().parseFromString(responseText, 'text/html');
                this.filterData = [...this.filterData, { html: responseText, url }];
                this.renderFilters(html_dom, event);
                this.renderProductGrid(html_dom);
                this.renderProductCount(html_dom);
            });
        }

        /**
         * Render section from cache.
         * 
         * @param {function} filterDataUrl A function.
         * @param {object} event Event.
         * @returns {undefined}
         */
        renderSectionFromCache(filterDataUrl, event) {
            const html = this.filterData.find(filterDataUrl).html;
            const html_dom = new DOMParser().parseFromString(html, 'text/html');
            this.renderFilters(html_dom, event);
            this.renderProductGrid(html_dom);
            this.renderProductCount(html_dom);
        }

        /**
         * Render product grid.
         * 
         * @param {object} html_dom Page html dom.
         * @returns {undefined}
         */
        renderProductGrid(html_dom) {
            let productGrid = document.getElementById('CollectionProductGrid');
            if (productGrid) {
                let newProductGrid = html_dom.getElementById('CollectionProductGrid');
                if (newProductGrid) {
                    requestAnimationFrame(() => {
                        productGrid.innerHTML = newProductGrid.innerHTML;
                        document.getElementById('CollectionProductGrid').classList.remove('collection-filter-loading');
                        this.initWishlistButton();
                    });
                }
            }
        }

        /**
         * Render product count.
         * 
         * @param {object} html_dom Page html dom.
         * @returns {undefined}
         */
        renderProductCount(html_dom) {
            let productQty = document.querySelectorAll('[data-collection-filter-product-qty]');
            let search = document.querySelector('[data-search-filter-product-qty]');
            let newproductQty = html_dom.querySelector('[data-collection-product-qty]');

            if (newproductQty) {
                productQty.forEach(elem => {
                    elem.innerHTML = newproductQty.value === '1' ? `${newproductQty.value} item` : `${newproductQty.value} items`;
                });
                if (search) {
                    search.innerHTML = newproductQty.value === '1' ? `${newproductQty.value} result` : `${newproductQty.value} results`;
                }
            }
        }

        /**
         * Render filters.
         * 
         * @param {object} html_dom Page html dom.
         * @param {object} event Event.
         * @returns {undefined}
         */
        renderFilters(html_dom, event) {
            const facetsToRender = html_dom.querySelector('[data-facets-elements]');
            document.querySelector('[data-facets-elements]').innerHTML = facetsToRender.innerHTML;

            this.renderActiveFacets(html_dom);
            this.renderAdditionalElements(html_dom);
            this.renderCounts();
        }

        /**
         * Render active facets.
         * 
         * @param {object} html_dom Page html dom.
         * @returns {undefined}
         */
        renderActiveFacets(html_dom) {
            const activeFacetElementSelectors = ['.active-facets'];
            activeFacetElementSelectors.forEach((selector) => {
                const activeFacetsElement = html_dom.querySelector(selector);
                if (activeFacetsElement) {
                    document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
                }
            });
        }

        /**
         * Render additional elements.
         * 
         * @param {object} html_dom Page html dom.
         * @returns {undefined}
         */
        renderAdditionalElements(html_dom) {
            const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
            mobileElementSelectors.forEach((selector) => {
                if (html_dom.querySelector(selector)) {
                    document.querySelector(selector).innerHTML = html_dom.querySelector(selector).innerHTML;
                }
            });
        }

        /**
         * On history change.
         * 
         * @param {object} event Event.
         * @returns {undefined}
         */
        onHistoryChange(event) {
            const searchParams = event.state?.searchParams || '';
            if (searchParams !== this.lastSearchParams) {
                this.lastSearchParams = searchParams;
                this.renderPage(searchParams, null, false);
            }
        }

        /**
         * Count the filter selected in which filter
         * 
         * @returns {undefined}
         */
        countRenderFiltersSelected() {
            const filter = this.querySelectorAll('[data-filter-types]');
            if (filter.length > 0) {
                filter.forEach(element => {
                    let count = element.querySelectorAll('input:checked').length;
                    let counterElement = element.querySelector('[data-selected-filter-count]');
                    counterElement.dataset.selectedFilterCount = count.toString();
                });
            }
        }

        /**
         * Render counts.
         * 
         * @returns {undefined}
         */
        renderCounts() {
            const count = document.getElementById('activeFacetsCount').dataset.count;
            document.querySelectorAll('[data-filter-count]').forEach(element => {
                element.dataset.filterCount = parseInt(count);
            });
        }

        /**
         * Update URL hash.
         * 
         * @returns {undefined}
         */
        updateURLHash(searchParams) {
            history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
        }

        /**
         * Changes the collection view
         * 
         * @returns {undefined}
         */
        filterSwitchOption() {
            const options = document.querySelectorAll('.toolbar-options .toolbar-icon');
            const filterOption = document.querySelector('[data-filter-view]');
            if (options && filterOption) {
                options.forEach(option => {
                    option.addEventListener('click', (e) => {
                        let currentOption;
                        options.forEach(item => item.classList.remove('active'));
                        currentOption = option.classList.contains('toolbar__grid-view') ? 'grid' : 'list';
                        option.classList.add('active');
                        filterOption.dataset.filterView = currentOption;
                        localStorage.setItem('preference-view', currentOption);
                    });
                });
            }

            //View Preference
            if (options && filterOption) {
                let preference_view = localStorage.getItem('preference-view') || "list";
                let selected_option_class = `toolbar__${preference_view}-view`;
                filterOption.dataset.filterView = preference_view;
                options.forEach(option => {
                    option.classList.toggle('active', option.classList.contains(selected_option_class));
                });
            }

            let collectionPlaceholder = document.querySelector("[data-grid-list-placeholder]");
            if (collectionPlaceholder) {
                collectionPlaceholder.classList.add("hidden");
            }
        }

        /**
         * Init Wishlist button
         * 
         * @returns {undefined}
         */
        initWishlistButton() {
            let selector = "#CollectionProductGrid";
            if (window._swat) {
                window._swat.initializeActionButtons(selector);
            } else {
                window.SwymCallbacks = window.SwymCallbacks || [];
                window.SwymCallbacks.push(function () {
                    window._swat.initializeActionButtons(selector);
                });
            }
        }

    }

    customElements.define('collection-filters', CollectionFilters);
}